<template>
    <div class="parent-container">
        <div class="content-container" >
            <div class="topic-sign-title-top">活动资料复审</div>
            <div class="topic-sign-name">（{{info.raceName}}）</div>
            <!--报名资料-->
            <div class="topic-info-container">
                <div class="topic-info-left">
                    <div class="item-title-container">
                        <div :class="activeTab===1?'item-title title-active':'item-title'" @click="handleTabsClick(1)">基本信息</div>
                        <div :class="activeTab===2?'item-title title-active':'item-title'" @click="handleTabsClick(2)">附件说明</div>
                    </div>
                    <el-form ref="topicForm" :model="info" :label-width="100" label-position="top">
                        <el-scrollbar class="topic-info-bar" v-if="activeTab===1">
                            <el-row>
                                <el-col :span="14" >
                                    <el-form-item label="教师姓名" prop="trueName">
                                        <el-input disabled v-model="info.trueName" placeholder="请输入教师姓名"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="所属学校" prop="orgName">
                                        <el-input disabled v-model="info.orgName" placeholder="请输入所属学校"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="任教学段" prop="periodKey">
                                        <el-select disabled style="width: 100%;" v-model="info.periodKey"
                                                   placeholder="请选择任教学段">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="任教学科" prop="subjectKey">
                                        <el-select disabled style="width: 100%;" v-model="info.subjectKey"
                                                   placeholder="请选择任教学科">
                                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="最高学历" prop="qualificationKey">
                                        <el-select disabled style="width: 100%;" v-model="info.qualificationKey"
                                                   placeholder="请选择最高学历">
                                            <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="技术职称" prop="rankLevel">
                                        <el-select disabled style="width: 100%;" v-model="info.rankLevel"
                                                   placeholder="请选择技术职称">
                                            <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="课例名称" prop="lessonName">
                                        <el-input disabled v-model="info.lessonName" placeholder="请输入课例名称"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-scrollbar>
                        <el-scrollbar class="topic-info-bar" v-if="activeTab===2">
                            <!--附件内容 -->
                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    <span style="color: red">*</span>教案、教学设计
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.jxsjFileList" :key="item">
                                        <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    <span style="color: red">*</span>教学课件
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.jxkjFileList" :key="item">
                                        <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    教学实施报告
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.ssbgFileList" :key="item">
                                        <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    课堂实录
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.ktslFileList" :key="item">
                                        <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_bf.png')"
                                                      @click="openVideo(item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                        </div>
                                    </div>
                                    <data-empty :is-img="false" title="暂无此类文件" v-if="info.ktslFileList&&info.ktslFileList.length===0"  />
                                </div>
                            </div>

                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    <span style="color: red">*</span>微课、微视频
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.wkspFileList" :key="item">
                                        <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_bf.png')"
                                                      @click="openVideo(item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                        </div>
                                    </div>
                                    <data-empty :is-img="false" title="暂无此类文件" v-if="info.wkspFileList&&info.wkspFileList.length===0"  />
                                </div>
                            </div>

                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    教学资源包
                                </div>
                                <div class="file-list">
                                    <div class="file-item" v-for="item in info.jxzyFileList" :key="item">
                                        <div class="file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                        <div class="file-view">
                                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                      :src="require('@/assets/file/file_view_color.png')"
                                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                            </el-image>
                                        </div>
                                        <div class="file-view" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#0d55a4"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#0d55a4"></path></svg>
                                        </div>
                                    </div>
                                    <data-empty :is-img="false" title="暂无此类文件" v-if="info.jxzyFileList&&info.jxzyFileList.length===0"  />
                                </div>
                            </div>


                            <div class="topic-file-container">
                                <div class="topic-file-item-title">
                                    补充说明
                                </div>
                                <div>
                                    <el-input
                                      disabled
                                      v-model="info.remarks"
                                      :rows="4"
                                      type="textarea"
                                      placeholder=""
                                    />
                                </div>
                            </div>
                        </el-scrollbar>
                    </el-form>
                </div>
                <div class="topic-info-right">
                    <div class="check-user-info" v-if="isRate===0">复审得分:--</div>
                    <div class="check-user-info" v-if="isRate===1">复审得分:{{this.rateInfo.rateScore}}</div>
                    <el-scrollbar class="check-info-container">
                        <div class="scale-title-container">
                            {{this.scaleInfo.scaleName}}
                        </div>
                        <div class="mb20" v-for="(item, index) in scaleInfo.eduItemList" style="width: 98%;">
                            <div class="mb10">
                                <h4 style="margin: 0 0;">
                                    <span style="padding-right: 10px;">
                                        {{ index + 1 }}.{{item.itemName }}
                                    </span>
                                    <span style="color: #efa030;font-weight: normal;font-size: 14px;">
                                        ({{item.itemScore }}分)
                                    </span>
                                </h4>
                            </div>
                            <div>
                                <div v-for="(items, indexs) in item.itemList" style="text-indent: 10px;font-size: 14px;margin-bottom: 5px;">
                                    <span style="color: #333;" v-if="isRate===0">
                                        {{ indexs + 1 }}.{{ items.itemName }}（{{ items.itemScore }}分）
                                    </span>
                                    <span style="color: #333;" v-if="isRate===1">
                                        {{ indexs + 1 }}.{{ items.itemName }}（{{ items.rateScore }}分）
                                    </span>
                                </div>
                            </div>
                            <div v-if="isRate===1">
                                <el-progress :percentage="item.rateNum">
                                    <el-button text>{{item.rateScore}}</el-button>
                                </el-progress>
                            </div>
                        </div>
                    </el-scrollbar>
                    <div class="apply-btn-container" >
                        <div class="apply-btn-back" @click="backRaceManager">返回</div>
                        <div v-if="isRate===0" class="apply-btn" @click="reviewRaceSign">评审</div>
                    </div>
                </div>
            </div>
        </div>

        <!--音视频播放-->
        <el-dialog v-model="isShowVideo" width="76%" top="50px" @close="closeIframe">
            <iframe id="open-video" style="width: 100%;height:calc(100vh - 250px)" :src="videoSrc"
                    frameborder="0"></iframe>
        </el-dialog>
        <!--评审-->
        <el-dialog v-model="isShowRate" width="700px">
            <el-form ref="scaleForm" :model="scaleInfo">
                <div class="scale-title-container">
                    {{this.scaleInfo.scaleName}}
                </div>
                <div class="mb20" v-for="(item, index) in scaleInfo.eduItemList" style="width: 98%;">
                    <div>
                        <h3 style="margin: 0 0;">
                            <span style="padding-right: 10px;">
                                {{ index + 1 }}.{{item.itemName }}
                            </span>
                            <span style="color: #efa030;font-weight: normal;font-size: 14px;">
                                ({{item.itemScore }}分)
                            </span>
                        </h3>
                    </div>
                    <div>
                        <div v-for="(items, indexs) in item.itemList" style="text-indent: 10px;font-size: 15px;margin-bottom: 5px;">
                            <span style="color: #333;">
                                {{ indexs + 1 }}.{{ items.itemName }}{{ items.itemName }}（{{ items.itemScore }}分）
                            </span>
                            <el-input-number size="small" style="width: 90px" v-model="items.rateScore" :min="1" :max="items.itemScore" />
                        </div>
                    </div>
                </div>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitCheckInfo">确 定</el-button>
                    <el-button @click="isShowRate = !isShowRate">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { infoActivitySign , fsActivitySignCheck} from "@/api/admin/raceSign"
import {timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import {downloadFile} from "@/api/adminservice/public";
import dataEmpty from "@/components/dataEmpty.vue";
export default {
    name: "fsActivitySignCheck",
    components: {dataEmpty},
    props:{
        infoId:{
            type: String,
            default:null,
        },
        rateStatus:{
            type: Number,
            default:0,
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.signId = newValue;
            this.getRaceSignInfo()
        },
        rateStatus(newValue,oldValue){
            this.isRate = newValue;
            this.getRaceSignInfo()
        },
    },
    data() {
        return {
            listMode:'list',
            showMode:'list',
            serviceUrl,
            timestampToTime,
            activeTab:1,
            signId:'',
            isRate:0,
            status:0,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            info:{},
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            checkForm:{
                signId:'',
                scaleId:'',
                rateType:3,
                rateScore:null,
                scaleInfo:{}
            },
            isShowVideo:false,
            isShowRate:false,
            videoSrc:'',
            rateInfo:{},// 报名及评审信息
            scaleInfo:{}, // 量表内容
        };
    },
    created() {},
    mounted() {
        this.signId = this.infoId
        this.isRate = this.rateStatus
        this.checkForm.signId = this.signId
        this.getRaceSignInfo()
    },
    unmounted() {},
    computed: {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
                this.subjectList = [];
                this.periodList.forEach(j => {
                    if (this.info.periodKey === j.dictKey) {
                        this.subjectList = j.childrenList;
                    }
                })
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        handleTabsClick(item){
            this.activeTab = item;
        },
        getRaceSignInfo() {
            infoActivitySign({ signId: this.signId }).then(res => {
                if (res.data.code === 1) {
                    this.info = res.data.data;
                    this.rateInfo = this.info.fsRateInfo
                    this.scaleInfo = this.info.fsScale;
                    this.getQueryDict()
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {

            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,fileType,fileUrl){
            const list = [];
            if (fileType &&(fileType.toLowerCase()==='png'||fileType.toLowerCase()==='jpg'||fileType.toLowerCase()==='jpeg')){
                list.push(fileUrl);
            }else {
                for (let i = 1; i <=page ; i++) {
                    list.push(baseUrl+'/' + i+'.png');
                }
            }

            return list;
        },
        handleCheckChange(selItem){
            this.checkForm.isCheck = selItem;
        },
        submitCheckInfo(){
            // 是否校验通过
            let isYes = true;
            // 总分
            let scoreTotal = 0;
            // 评审项
            this.scaleInfo.eduItemList.forEach((e, i) => {
                // 当前评审项 分数
                let score = 0;
                e.itemList.forEach(i => {
                    if (i.rateScore===null||i.rateScore===''||i.rateScore===undefined){
                        isYes = false;
                    }else {
                        score = score + i.rateScore;
                    }

                });
                e.rateScore = score;
                console.log(e.itemName+"当前评审项分数"+score);
                scoreTotal = scoreTotal + score;
            })
            console.log("评审项总分数"+scoreTotal);
            if (!isYes){
                this.$message.error("评分项存在漏评，请您检查")
                return;
            }
            this.checkForm.rateScore = scoreTotal;
            this.checkForm.scaleId = this.scaleInfo.scaleId;
            this.checkForm.scaleInfo = this.scaleInfo;
            fsActivitySignCheck(this.checkForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功")
                    this.backRaceManager();
                }else{
                    this.$message.error("请求出错")
                }
            })

        },
        backRaceManager(){
            this.$emit('change-active-mode', this.listMode,"3");
        },
        openVideo(url){
            this.videoSrc = url;
            this.isShowVideo = true;
        },
        closeIframe() {
            const iframe = document.getElementById("open-video"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
        reviewRaceSign(){
            this.isShowRate = true;
        },
    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title-top{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #0d55a4;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    text-align: center;
}
.topic-info-container{
    width: 100%;
    height: auto;
    border-top: 2px solid #0d55a4;
    display: flex;
}
.topic-info-left{
    width: calc(100% - 302px);
    height: 100%;
    border-right: 2px solid #0d55a4;
}
.topic-info-right{
    width: 300px;
    height: 100%;
}
.item-title-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.item-title{
    width: auto;
    height: 30px;
    margin-right: 10px;
    line-height: 30px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
}
.title-active{
    color: #0d55a4!important;
    border-bottom: 3px solid #0d55a4!important;
}
.topic-info{
    width: 100%;
    height:100%;
    padding-top: 10px;
}
.topic-info-bar{
    width: 100%;
    height:calc(100vh - 220px);
    padding-top: 10px;
}
/deep/ .el-form-item{
    margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#000!important;
    font-weight:bold;
    font-size:14px
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    color:#000!important;
    font-weight:bold;
    font-size:14px;
    line-height: 25px;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    color: #0d55a4;
}
.file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
.check-user-info{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
}
/*量表*/
.check-info-container{
    width: 90%;
    height: 360px;
    margin: auto;
    border: 1px solid #0d55a4;
    padding: 0 10px 0 10px;
}
.check-sel{
    width: 100%;
    height: 40px;
    margin: auto;
    display: flex;
}
.btn-tg{
    height: 24px;
    width: 70px;
    background-color: #81b337;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    margin-right: 10px;
    border-radius: 5px;
    margin-left: 60px;
    cursor: pointer;
}
.btn-tg-auto{
    height: 24px;
    width: 70px;
    background-color: #81b337;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
    margin: auto;
}
.btn-jj{
    height: 24px;
    width: 70px;
    background-color: #e87b17;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
}
.btn-jj-auto{
    height: 24px;
    width: 70px;
    background-color: #e87b17;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
    margin: auto;
}
.reason-title-container{
    display: flex;
    width: 100%;
    height: 25px;
    color:#000!important;
    font-weight:bold;
    font-size:14px;
    line-height: 25px;
    text-indent: 10px;
}
.reason-container{
    width: 100%;
    height: auto;
    padding-left: 10px;
    padding-top: 10px;
    box-sizing: border-box;

}
.apply-btn-container{
    width: 90%;
    height: 40px;
    display: flex;
    padding: 20px 0 0 20px;
}
.apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}
.topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-file-item-title{
    height: 30px;
    color:#333333;
    font-weight:bold;
    font-size:14px
}
.scale-title-container{
    width: 100%;
    height: auto;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
    color: #0d55a4;
    text-align: center;
}
</style>